import React from "react"

// styles
import { Head } from "./HeaderStyles"

export default function Header() {
  return (
    <Head>
      <img src='/img/Logo-Transparent.svg' alt='Logo' />
      <h1>Madrid Waves</h1>
    </Head>
  )
}
